function handleFilters() {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedFilters = [];

  // Loop through filter options and push selected filters to array
  ['pf_t_style', 'pf_t_material', 'pf_opt_size'].forEach((option) => {
    const selectedOption = urlParams.get(option);
    if (selectedOption) {
      selectedFilters.push(selectedOption);
    }
  });

  const filterButton = document.querySelector('.filter-tree-button');

  // Set filterButton text to selected filters with correct formatting
  if (selectedFilters.length > 0) {
    filterButton.textContent = selectedFilters.map((filter) => {
      return filter.split(' ').map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    }).join(' | ');
  }
}

$(document).ready(function () {
    setTimeout(function () {
        var productImage = $('.boost-pfs-filter-product-item-main-image')
        var filterToggle = $('.filter-tree-button-container')
        var filterContent = $('.filter-tree-content-container')
        var filterTree = $('.filter-tree-container')
        var mobileClose = $('.filter-tree-mobile-close')
        var overlay = $('.filter-overlay')
        
        // 1. menuItems returns an array of the filter menu items.
        var menuItems = document.getElementsByClassName('boost-pfs-filter-option-item')
        
        // 2. productTitle is the html we inject at our chosen position in the menuItems array.
        var productTitle = '<div style="pointer-events: none;margin-left: 8px;margin-top: 30px;margin-bottom: 15px;" class="boost-pfs-filter-option-title"><span class="boost-pfs-filter-option-title-text">PRODUCTS</div>';
        
      	// 3. and then here's where that insertion takes place.
        //$(productTitle).insertAfter(menuItems[3])
    	      
        // when a user clicks a filter option inside the mobile menu. 
        if(jQuery( window ).width() <= 767){
          document.addEventListener("click", (e) => {
            if(e.target.classList.contains("boost-pfs-filter-button") || e.target.classList.contains("boost-pfs-filter-option-value")){
              handleFilters();
              mobileClose.click();
            } 
          })
        }
      
        if (productImage.length > 0) {
            productImage.matchHeight()
        }

        ProductList.prototype.afterRender = function() { 
            var productImage = $('.boost-pfs-filter-product-item-main-image')
        
            if (productImage.length > 0) {
                productImage.matchHeight()
            }
        }

        filterToggle.on('click', function () {
            filterContent.toggleClass('active')
            filterTree.toggleClass('active')
            filterToggle.toggleClass('hide')
            overlay.toggleClass('active')
            // prevent body from scrolling when mobile menu is open
            // set html height to 100%
            document.documentElement.style.height = '100%';
            // set body to overflow hidden
            document.body.style.overflow = 'hidden';
            // set body height to 100%
            document.body.style.height = '100%';
            
        })

        mobileClose.on('click', function () {
            filterContent.toggleClass('active')
            filterTree.toggleClass('active')
            filterToggle.toggleClass('hide')
            overlay.toggleClass('active')
            // activate body scrolling when mobile menu is closed
            // set html height to auto
            document.documentElement.style.height = 'auto';
            // set body to overflow auto
            document.body.style.overflow = 'auto';
            // set body height to auto
            document.body.style.height = 'auto';
        })

        

            
    }, 2000)
    
      // Hiding STYLE sidebar
    document.arrive(".boost-pfs-filter-option", () => {

      let filterClass = document.querySelector(".boost-pfs-filter-option");
      const searchWord = "STYLE";
      let loopedWord = filterClass.innerText;

      while(!(loopedWord.toLowerCase().includes(searchWord.toLowerCase))){
        filterClass = filterClass.nextElementSibling;
        if(filterClass == null) return;
        loopedWord = filterClass.innerText.toLowerCase();
      }

      if(loopedWord == searchWord.toLowerCase()){
        filterClass.style.display = "none";
      }
    });
      /*
      NOTE: We can use the below code to replace the above if there are multiple sidebar sections we want to remove.
      document.arrive(".boost-pfs-filter-option", () => {

        let filterClass = document.querySelector(".boost-pfs-filter-option");
        const searchWordArr = ["STYLE"];
    		let loopedWord = filterClass.innerText;

        searchWordArr.forEach((word, idx) => {

          while(!(loopedWord.toLowerCase().includes(word.toLowerCase()))){
            filterClass = filterClass.nextElementSibling;
            if(filterClass == null) return;
            loopedWord = filterClass.innerText;
          }
          console.log("loopedWord: ", loopedWord)

          if(loopedWord.includes(word)){
            filterClass.style.display = "none";
          }
        })
      });
      */

})
